<template>
  <div>
    <v-dialog
      @keydown.esc="isOpen=false"
      v-model="isOpen"
      persistent
      max-width="400">
      <v-card>
        <v-card-title>
          <!-- Agrega un producto a la orden {{ order.uuid }} -->
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            v-model="validAddProduct">
            <v-row>
              <v-col cols="12">
                <v-list-item>
                  <v-list-item-content v-if="!loading">
                    <v-list-item-title>
                      {{ product.name }}
                    </v-list-item-title>
                  </v-list-item-content>

                  <loader v-else :size="20" :loading="loading" />
                </v-list-item>
              </v-col>
              <v-col cols="12">
                <v-select
                  ref="choice_select"
                  v-model="form.data.variant"
                  :disabled="choices.disabled"
                  :items="choices.data"
                  label="Presentación"
                  item-text="name"
                  item-value="_id"
                  return-object
                  :rules="form.rules.required"
                  @change="selectVariant"
                  @keyup.up="activateChoiceMenu"
                  @keyup.down="activateChoiceMenu"
                />
              </v-col>
            </v-row>
          </v-form>
          <div
            v-if="productsCatalogPermissions['create-product']"
            class="display-flex justify-between">
            <v-list-item>
              <v-list-item-title>
                Agregar una presentación nueva
              </v-list-item-title>
              <v-list-item-action>
                <v-btn
                  data-cy="addProduct"
                  fab
                  x-small
                  depressed
                  color="primary"
                  @click="openCreateProductDialog"
                >
                  <v-icon color="white">mdi-plus</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            rounded
            outlined
            color="primary"
            @click.stop="cancelAddProduct">
            Cancelar
          </v-btn>
          <v-btn
            rounded
            color="primary"
            @click.stop="updatePrice">
            Entendido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddVariant ref="addVariant" @add="addVariant"/>
  </div>
</template>

<script>
import AddVariant from '@/components/modals/AddVariant'
import Loader from '@/components/Loader'
import Order from '@/models/Order'

export default {
  components: {
    AddVariant,
    Loader
  },
  data () {
    let orderModel = new Order()

    return {
      isOpen: false,
      loading: false,
      validAddProduct: false,
      product: {},
      choices: {
        data: [],
        disabled: true,
        loading: false
      },
      form: {
        data: {
          variant: null
        },
        rules: {
          required: [v => !!v || this.$t('validations.required')]
        }
      },
      orderModel,
      item: {}
    }
  },
  computed: {
    provider () {
      return this.$store.state.currentProvider.data || ''
    },
    productsCatalogPermissions () {
      return this.$store.state.login.permissions['products-catalog'].components['products-catalog-list'].actions
    }
  },
  methods: {
    openCreateProductDialog () {
      this.$refs.addVariant.open()
    },
    open (order, item) {
      this.isOpen = true
      this.orderModel = new Order(order.$ || order)
      this.item = { ...item }
      this.loadProduct(item.product)
    },
    close () {
      this.isOpen = false
      this.choices.disabled = true
    },
    cancelAddProduct () {
      this.close()
      this.resetForm()
    },
    productSelected (product) {
      if (product) {
        const providerChoices = product.prices
          .filter(choice => choice.provider === this.provider._id)
          .map(choice => ({
            ...choice,
            name: `${choice.displayQuantity} ${choice.displayUnit.name} de ${choice.contentQuantity} ${choice.contentUnit.name} | $${Number(choice.amount).toFixed(2)}`
          }))
        this.choices.data = providerChoices
        this.choices.disabled = !providerChoices.length
      }
    },
    async loadProduct (productId) {
      this.loading = true
      try {
        const response = await this.$api.get(`/v1/catalog/product/${productId}`)
        this.product = response
        this.productSelected(response)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading = false
    },
    activateChoiceMenu (item) {
      this.$refs[`choice_select`].activateMenu()
    },
    async addVariant (variant) {
      this.loading = true

      const product = this.product.name
      const category = this.product.category
      const type = this.product.type

      const payload = {
        name: product,
        category: category,
        type: type,
        displayUnit: variant.displayUnit,
        contentQuantity: variant.contentQuantity,
        contentUnit: variant.contentUnit,
        amount: variant.amount,
        brand: variant.brand,
        yield: variant.yield,
        satCode: variant.satCode
      }
      try {
        await this.$api.post('/v1/catalog', payload)
        await this.loadProduct(this.product._id)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading = false
    },
    async updatePrice () {
      this.overlay = true
      const payload = {
        restaurant: this.orderModel.$.restaurant._id,
        items: [
          {
            id: this.item._id,
            quantity: this.item.quantityConfirmed,
            amount: this.item.amount,
            taxes: this.item.taxes,
            choice: this.item.choice,
            unit: this.item.unit
          }
        ]
      }
      try {
        await this.orderModel.update(payload)
        this.$emit('updated')
        this.$toasted.show(`La presentación del producto ${this.item.name} se actualizo correctamente`, { duration: 3000 })
        this.close()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    selectVariant (variant) {
      this.item.choice = variant._id
      this.item.unit = variant.displayUnit._id
      this.item.taxes = variant.taxes
      this.item.amount = variant.amount
    }
  }
}
</script>
